// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kasgQ","maintitle":"Header_maintitle__V1CQc","icon":"Header_icon__je6+n","main-image":"Header_main-image__KKmbl"};